<template>
  <div class="animated fadeIn">

    <div class="row">
      <div class="col">
        <b-btn @click="searchModalShow = !searchModalShow">Filter</b-btn>
        <span> By </span>
        <span v-if="searchObject.taxInvoice.length > 0">[tax invoice]: {{searchObject.taxInvoice}} </span>
        <span v-if="searchObject.customerAccount.length > 0">and [customer account]: {{searchObject.customerAccount}} </span>
        <span v-if="searchObject.status.length > 0">and [status]: {{searchObject.status}} </span>
        <!-- <span v-if="searchObject.orderDate.length != null">{{searchObject.orderDate}} and </span> -->
        <b-btn @click="clearFilters()">Clear Filters</b-btn>
      </div>
    </div>

    <!-- Modal Component -->
    <b-modal id="modal1" title="Filter" v-model="searchModalShow">
      <!-- Body -->
      <b-row class="mb-1">
        <b-col><label for="taxInvoiceInput">Tax Invoice:</label></b-col>
        <b-col><input type="text" id="taxInvoiceInput" placeholder="" v-model="searchObject.taxInvoice"></b-col>
      </b-row>
      <b-row>
        <b-col><label for="filterCusAcc">Customer Account:</label></b-col>
        <b-col><input type="text" id="filterCusAcc" placeholder="" v-model="searchObject.customerAccount"></b-col>
      </b-row>
      <b-row>
        <b-col><label for="filterStatus">Status:</label></b-col>
        <b-col>
          <!-- <input type="text" id="filterStatus" placeholder="" v-model="searchObject.status"> -->
          <b-dropdown id="filterStatus" :text="searchObject.status" class="m-md-1">
            <b-dropdown-item href="#" @click="searchStatusSelected('')"></b-dropdown-item>
            <b-dropdown-item href="#" @click="searchStatusSelected('NEW')">NEW</b-dropdown-item>
            <b-dropdown-item href="#" @click="searchStatusSelected('CLAIMING')">CLAIMING</b-dropdown-item>
            <b-dropdown-item href="#" @click="searchStatusSelected('CLAIMED')">CLAIMED</b-dropdown-item>
          </b-dropdown>
        </b-col>
      </b-row>
      <b-row>
        <b-col><label for="filterFromOrderDate">From Order Date (DD/MM/YYYY):</label></b-col>
        <b-col>
          <input type="date" id="filterFromOrderDate" placeholder="DD/MM/YYYY" v-model="searchObject.orderDate">
          <!--<div class="FormDate">-->
            <!--<input-->
              <!--class="FormDate__input FormDate__input&#45;&#45;day"-->
              <!--type="number"-->
              <!--placeholder="dd" max="2">-->
            <!--<span class="FormDate__divider">/</span>-->
            <!--<input-->
              <!--class="FormDate__input FormDate__input&#45;&#45;month"-->
              <!--type="number" max="2"-->
              <!--placeholder="mm">-->
            <!--<span class="FormDate__divider">/</span>-->
            <!--<input-->
              <!--class="FormDate__input FormDate__input&#45;&#45;year"-->
              <!--type="number" max="4"-->
              <!--placeholder="yyyy">-->
          <!--</div>-->
          <!-- <DateTimePicker format="DD/MM/YYYY h:i:s" id="filterOrderDate" v-on:update:date-value="updateFilterOrderDate"/> -->
        </b-col>
      </b-row>
      <!-- Footer -->
      <div slot="modal-footer" class="w-100">
        <b-btn size="sm" variant="primary" @click="search()">
          Filter
        </b-btn>
        <b-btn size="sm" class="float-right" variant="primary" @click="searchModalShow = !searchModalShow">
          Close
        </b-btn>
      </div>
    </b-modal>

    <div class="row">
      <div class="col">
        <span> Rows Per Page:</span>
        <b-dropdown id="ddown3" :text="rowsPerPageCText" class="m-md-1">
          <b-dropdown-item href="#" @click="rowsPerPageSelected(10)">10</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(20)">20</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(50)">50</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(100)">100</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(150)">150</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(200)">200</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(500)">500</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(1000)">1000</b-dropdown-item>
        </b-dropdown>
      </div>
      <div class="col" align="center">
        <b-pagination
          size="sm"
          :total-rows="totalRowsC"
          v-model="currentPage"
          :per-page="rowsPerPageC"
          hide-ellipsis
          :limit="paginationButtonsLimit"
          align="center"
          @change="pageChanged"
          :disabled="disabledPagination"
        >
        </b-pagination>
      </div>
      <div class="col" align="right">
        <span>Total Rows {{totalRowsC}}</span>
      </div>
    </div>

    <br/>
    <button type="button" class="btn btn-primary" @click="refreshTable()">Refresh</button>
    <button type="button" class="btn btn-primary" @click="generateInvoiceReport()">Generate Invoice Report</button>
    <!-- <b-table small bordered hover responsive="true" :items="tableRows" :fields="tableHeaders" @row-clicked="tableRowClicked"> -->
    <b-table small bordered hover :items="tableRows" :fields="tableHeaders">

      <template slot="cell(show_details)" slot-scope="row">
        <button type="button" class="btn btn-primary" @click="showRowDetailClicked(row.item.taxInvoice, row.item.invoiceId)">Details</button>
      </template>
      <template slot="cell(show_campaign_claims)" slot-scope="row">
        <button type="button" class="btn btn-secondary" @click="showCampaignClaims(row.item.taxInvoice, row.item.invoiceId)">Campaign Claims</button>
      </template>
      <template slot="row-details" slot-scope="row">
        <b-card-group style="overflow: scroll">
          <b-card v-for="subType of row.item.subTypes" v-bind:data="subType" v-bind:key="subType.__id"
                  style="min-width: 300px">
            <b-row v-for="(eachProp, propName) in subType" :data="eachProp" :key="propName">
              <b-col><b>{{propName}}:</b></b-col>
              <b-col>{{ eachProp }}</b-col>
            </b-row>
          </b-card>
        </b-card-group>
      </template>
    </b-table>

    <b-modal id="campaignClaimsModal" size="xl" :title="'Campaign Claims: ' + selectedClaimTaxInvoice" v-model="campaignClaimsModalShow">
      <section class="campaign-claim-section">
        <h5>Selected by customer</h5>
        <p class="text-muted">This invoice was chosen first by the customer.</p>
        <div class="campaign-claim-table-wrap">
          <b-table
            small
            bordered
            show-empty
            class="invoice-claim-detail-table"
            :items="requestedClaimDetails"
            :fields="claimDetailHeaders">
            <template slot="cell(claimSubtypesText)" slot-scope="data">
              <div class="claim-quantity-cell">{{data.value || '-'}}</div>
            </template>
          </b-table>
        </div>
      </section>

      <section class="campaign-claim-section">
        <h5>Used as pairing invoice</h5>
        <p class="text-muted">This invoice supplied the second lens for another selected invoice.</p>
        <div class="campaign-claim-table-wrap">
          <b-table
            small
            bordered
            show-empty
            class="invoice-claim-detail-table"
            :items="pairingClaimDetails"
            :fields="claimDetailHeaders">
            <template slot="cell(claimSubtypesText)" slot-scope="data">
              <div class="claim-quantity-cell">{{data.value || '-'}}</div>
            </template>
          </b-table>
        </div>
      </section>

      <div slot="modal-footer" class="w-100">
        <b-btn size="sm" class="float-right" variant="primary" @click="campaignClaimsModalShow = false">
          Close
        </b-btn>
      </div>
    </b-modal>

    <img src="static/img/Rolling.svg" alt="Loading data..."
         style="margin-left:auto; margin-right:auto; display: block;"
         v-if="showLoadingAnimation">
    <p style="text-align: center"
       v-if="showLoadingError">
      Loading error:
    </p>
    <p style="text-align: center"
       v-if="showNoResult">
      No Result
    </p>


    <!-- <span>Selected tax invoice: {{ taxInvoice }}</span>
    <br/>
    <b-table small bordered hover responsive="true" :items="detailTableRows" :fields="detailTableHeaders">
    </b-table> -->

  </div>
</template>

<script>
  import { DateTimePicker } from '../components/'
  var moment = require('moment')
export default {
    components: {
      DateTimePicker
    },
    data () {
      return {
        currentPage: this.$store.state.invstomod.currentPage,
        paginationButtonsLimit: 3,
        searchObject: {
          taxInvoice: '',
          customerAccount: '',
          status: '',
          orderDate: ''
        },
        searchModalShow: false,
        campaignClaimsModalShow: false,
        selectedClaimTaxInvoice: ''
      }
    },
    created: function () {
      // we hook into the created lifecycle to start grabbing data from firestore
      this.$store.dispatch('invstomod/showAllInvoices', {orderBys: 'orderDate'})
    },
    methods: {
      updateFromOrderDate: function (dateString) {
        // this.$store.commit('invstomod/updateFromOrderDate', dateString)
        console.log('Updating from order date to: ' + dateString)
        if (dateString && dateString.length > 0) {
          let m = moment(dateString, 'DD/MM/YYYY')
          this.searchObject.orderDate = m.toDate()
          console.log('Updated from order date to: ' + this.searchObject.orderDate)
        }
      },
      updateToOrderDate: function (dateString) {
        this.$store.commit('invstomod/updateToOrderDate', dateString)
      },
      pageChanged: function (pageNumber) {
        this.currentPage = pageNumber
        console.log('User changed page to number: ' + this.currentPage)
        this.$store.commit('invstomod/changePageNumber', this.currentPage)
        this.$store.dispatch('invstomod/showAllInvoices', {orderBys: 'orderDate'})
      },
      rowsPerPageSelected: function (rows) {
        console.log('rowsPerPageSelected, rows: ' + rows)
        let intRows = parseInt(rows)
        if (this.$store.state.invstomod.rowsPerPage !== intRows) {
          this.currentPage = 1
          this.$store.commit('invstomod/changePageNumber', this.currentPage)
          this.$store.commit('invstomod/setRowsPerPage', intRows)
          this.$store.dispatch('invstomod/showAllInvoices', {orderBys: 'orderDate'})
        }
      },
      showRowDetailClicked: function (taxInvoice, invoiceId) {
        console.log('show row detail clicked: ' + taxInvoice)
        this.$store.commit('invstomod/selectTableRow', invoiceId)
        this.$store.commit('invstomod/updatedSelectedTaxInvoice', taxInvoice)
        this.$store.dispatch('invstomod/fetchInvoiceDetails', {taxInvoice: taxInvoice})
      },
      showCampaignClaims: function (taxInvoice, invoiceId) {
        console.log('show campaign claims clicked: ' + taxInvoice)
        this.selectedClaimTaxInvoice = taxInvoice
        this.$store.commit('invstomod/selectTableRow', invoiceId)
        this.$store.dispatch('invstomod/fetchInvoiceClaimDetails', {taxInvoice: taxInvoice}).then(() => {
          this.campaignClaimsModalShow = true
        })
      },
      tableRowClicked: function (item, index, event) {
        console.log('Table row clicked')
        console.log('item: ' + item)
        // console.log('index: ' + index)
        let taxInvoice = null
        for (let i in item) {
          // console.log('i: ' + i + ', ' + item[i])
          if (i === 'taxInvoice') {
            taxInvoice = item[i]
          }
        }
        this.$store.commit('invstomod/selectTableRow', item.invoiceId)
        this.$store.commit('invstomod/updatedSelectedTaxInvoice', taxInvoice)
        this.$store.dispatch('invstomod/fetchInvoiceDetails', {taxInvoice: taxInvoice})
      },
      search: function () {
        this.searchModalShow = false
        this.$store.dispatch('invstomod/searchInvoices',
          {
            taxInvoice: this.searchObject.taxInvoice,
            customerAccount: this.searchObject.customerAccount,
            status: this.searchObject.status,
            orderDate: this.searchObject.orderDate
          })
      },
      generateInvoiceReport: function () {
        this.$store.dispatch('invstomod/generateInvoiceReport')
      },
      refreshTable: function () {
        this.currentPage = 1
        this.$store.commit('invstomod/changePageNumber', this.currentPage)
        this.$store.dispatch('invstomod/showAllInvoices', {orderBys: 'orderDate'})
      },
      updateFilterOrderDate: function (dateString) {
        let m = moment(dateString, 'DD/MM/YYYY hh:mm:ss')
        this.searchObject.orderDate = m.toDate()
      },
      searchStatusSelected: function (selectedStatus) {
        this.searchObject.status = selectedStatus
      }
    },
    computed: {
      disabledPagination: function () {
        return this.$store.state.invstomod.disabledPagination
      },
      tableRows: function () {
        // return this.$store.getters['invstomod/getAll']

        console.log('all invoice', this.$store.state.invstomod.all)
        return this.$store.state.invstomod.all
      },
      tableHeaders: function () {
        return this.$store.getters['invstomod/getHeaders']
      },
      totalRowsC: function () {
        return this.$store.state.invstomod.totalRows
      },
      rowsPerPageC: {
        get: function () {
          return this.$store.state.invstomod.rowsPerPage
        },
        set: function (newValue) {
          this.$store.commit('invstomod/setRowsPerPage', newValue)
        }
      },
      rowsPerPageCText: function () {
        return '' + this.$store.state.invstomod.rowsPerPage
      },
      detailTableRows: function () {
        // return this.$store.getters['invstomod/getAll']
        return this.$store.state.invstomod.detailAll
      },
      detailTableHeaders: function () {
        return this.$store.getters['invstomod/getDetailHeaders']
      },
      requestedClaimDetails: function () {
        return this.$store.state.invstomod.claimDetails.requested
      },
      pairingClaimDetails: function () {
        return this.$store.state.invstomod.claimDetails.pairing
      },
      claimDetailHeaders: function () {
        return this.$store.getters['invstomod/getClaimDetailHeaders']
      },
      taxInvoice: {
        get: function () {
          return this.$store.state.invstomod.selectedTaxInvoice
        }
      },
      clearFilters () {
        if (this.searchObject.taxInvoice === '' && this.searchObject.customerAccount === '' &&
          this.searchObject.status === '' && this.searchObject.orderDate === null) {
          return
        }
        this.searchObject.taxInvoice = ''
        this.searchObject.customerAccount = ''
        this.searchObject.status = ''
        this.searchObject.orderDate = null
        this.currentPage = 1
        this.$store.commit('invstomod/changePageNumber', this.currentPage)
        this.$store.dispatch('invstomod/showAllInvoices', {orderBys: 'orderDate'})
      },
      showLoadingAnimation: function () {
        return this.$store.state.invstomod.showLoadingAnimation
      },
      showLoadingError: function () {
        return this.$store.state.invstomod.showLoadingError
      },
      showNoResult: function () {
        return this.$store.state.invstomod.showNoResult
      }
    },
    name: 'invoices'
  }
</script>

<style lang="scss">
  .FormDate {
    $spacing: 0.75em;
    display: inline-flex;
    position: relative;
    overflow: hidden;
    border: 1px solid #888;
    border-radius: 0.25em;
    // 1. Hide the spinner button in Chrome, Safari and Firefox.
    &__input {
      padding: $spacing;
      padding-right: $spacing / 2;
      padding-left: $spacing / 2;
      border: none;
      text-align: center;
      /* stylelint-disable-next-line property-no-vendor-prefix */
      -moz-appearance: textfield; // 1
      &::-webkit-inner-spin-button {
        display: none; // 1
      }
      &:first-child {
        padding-left: $spacing;
      }
      &:last-child {
        padding-right: $spacing;
      }
      &:focus {
        outline: none;
      }
      &--day,
      &--month {
        width: 3em;
      }
      &--year {
        width: 4em;
      }
    }
    &__divider {
      padding-top: $spacing;
      padding-bottom: $spacing;
      pointer-events: none;
    }
  }

  .invoice-claim-detail-table {
    margin-bottom: 16px;
    min-width: 980px;
  }

  .invoice-claim-detail-table /deep/ th,
  .invoice-claim-detail-table /deep/ td {
    white-space: nowrap;
    vertical-align: middle;
  }

  .claim-quantity-cell {
    min-width: 130px;
    white-space: pre-line;
  }

  .campaign-claim-section {
    margin-bottom: 24px;
  }

  .campaign-claim-section h5 {
    margin-bottom: 4px;
  }

  .campaign-claim-section p {
    margin-bottom: 12px;
  }

  .campaign-claim-table-wrap {
    border: 1px solid #d8e1ea;
    max-width: 100%;
    overflow-x: auto;
  }
</style>



// WEBPACK FOOTER //
// src/views/Invoices.vue